/**
 * Checked task marker, matching the app's Modern completion checkbox
 * (apps/web globals.css `.checkbox-task` under [data-style="modern"]):
 * a round green fill with a paper-coloured tick. `shape="square"` keeps the
 * rounded-square silhouette (the app's settings-checkbox shape) for
 * places where round reads wrong next to other elements.
 */
export function CheckMark({
  shape = 'round',
  size = 32,
  color = '#5F875E',
}: {
  shape?: 'round' | 'square'
  /** Default 32 keeps every existing use exactly as it was. */
  size?: number
  /** Fill of the badge. Defaults to the green, so existing uses are unchanged;
   *  sections pass their own accent where the marks should belong to them. */
  color?: string
}) {
  return (
    <div
      style={{ width: size, height: size, backgroundColor: color }}
      className={`flex items-center justify-center text-[#F7F1E7] ${
        shape === 'round' ? 'rounded-full' : 'rounded-[6px]'
      }`}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
        <path d="M11.2589 0.697125C11.6083 0.0376249 12.3929 -0.194988 13.0112 0.177685C13.6295 0.550446 13.8476 1.38727 13.4982 2.0468L7.22845 13.8787C6.84393 14.6043 5.94652 14.7995 5.32634 14.2923L0.503713 10.3484C-0.0599397 9.88752 -0.166679 9.02632 0.2654 8.42508C0.697534 7.82387 1.50492 7.71002 2.0686 8.17089L5.42356 10.9145C5.5786 11.0413 5.80294 10.9925 5.89908 10.8111L11.2589 0.697125Z" fill="currentColor"/>
      </svg>
    </div>
  )
}
